<template>
    <v-app-bar
        app
        flat
        :dark="dark"
        :color="color"
        :extended="extended"
        :extension-height="extensionHeight"
    >
        <Headful :title="title"></Headful>
        <v-btn icon @click="back" v-if="showBackButton" height="100%">
            <v-icon>fal fa-chevron-left</v-icon>
        </v-btn>
        <img v-else-if="!showLogo" src="../../assets/images/portaal-beeldmerk.png" width="140" height="90" />
        <img src="../../assets/images/portaal-logo.png" v-if="showLogo" class="toolbar-logo" />
        <v-toolbar-title v-if="title">
            {{ title }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-menu offset-y v-if="isLoggedIn">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    text color="white"
                    :icon="$vuetify.breakpoint.mdAndDown"
                >
                    <v-btn
                        elevation="0"
                        fab
                        small
                        color="primary"
                        dark
                    >
                        <v-icon small>fas fa-user</v-icon>
                    </v-btn>

                    <span class="ml-3 mr-2" v-if="$vuetify.breakpoint.lgAndUp">{{ user.name }}</span>
                    <v-icon v-if="$vuetify.breakpoint.lgAndUp">fal fa-angle-down</v-icon>
                </v-btn>
            </template>
            <v-list>
                <v-list-item @click="($route.name == 'Account') ? '' : $router.push({name: 'Account'})">
                    <v-list-item-title>Mijn gegevens</v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="$store.dispatch('logout')">
                    <v-list-item-title>Uitloggen</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

        <!-- Uitgelogde bezoekers (diensten) kunnen vanaf de publieke pagina's alsnog inloggen. -->
        <v-btn
            v-else-if="$route.name !== 'Login' && $route.name !== 'SignIn'"
            text
            color="white"
            :to="{ name: 'SignIn' }"
        >
            <v-icon :left="$vuetify.breakpoint.lgAndUp">fal fa-sign-in</v-icon>
            <span v-if="$vuetify.breakpoint.lgAndUp">Inloggen mobiliteitsportaal</span>
        </v-btn>
    </v-app-bar>
</template>

<script>
import {mapState} from "vuex";
import Headful from "@/components/layout/Headful";

export default {
    name: "Header",
    components: {
        Headful,
    },
    props: {
        title: {
            type: String,
            required: false,
        },
        extended: {
            type: Boolean,
            default: false,
        },
        extensionHeight: {
            type: Number,
            default: 48,
        },
        showBackButton: {
            type: Boolean,
            default: false,
        },
        showLogo: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: 'secondary',
            required: false
        },
        dark: {
            type: Boolean,
            default: true,
            required: false
        },
    },
    computed: {
        ...mapState({
            isLoggedIn: state => state.auth.isLoggedIn,
            user: state => state.auth.user
        }),
    },
    methods: {
        back() {
            if (this.$route.name === 'Profiles') {
                this.$router.push({name: 'Home'});
            } else if (window.history.length > 2) {
                this.$router.go(-1);
            } else if (this.isLoggedIn) {
                this.$router.push({name: 'Home'});
            } else {
                this.$router.push({name: 'Login'});
            }
        },
    },
}
</script>

<style scoped>

</style>
